<template>
	<svg width="64" height="48" version="1.1" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
		<g>
				<g>
					<path d="M17.572 23.933l4.106 7.095L32 13.189h-8.981V7.582L11.51.972 0 7.582v13.222l11.51 6.611 6.062-3.482zm10.96-8.744l-6.855 11.846-6.855-11.846h13.71z" fill="#ffffff"/>
				</g>
		</g>
	</svg>
</template>
<script>
  export default {
    name: 'logoSquare',
    props: ['light'],
  };
</script>


// WEBPACK FOOTER //
// src/components/LogoSquare.vue